/* stylelint-disable selector-type-no-unknown */
:root {
  --progressbarvaluelabel {
    position: absolute;
    font-weight: 700;
    font-size: 1.5em;
    margin: 0.25em;
  }
}
/* stylelint-enable selector-type-no-unknown */

.progressBar {
  position: relative;
  width: 100%;
  height: 3em;
  background-color: var(--white);
  border: 1px solid var(--blue);
  margin-bottom: 2em;
}

.progressBarValue {
  background-color: var(--blue);
  min-height: 100%;
}

.progressBarValueLabel {
  @apply --progressbarvaluelabel;

  color: var(--white);
}

.progressBarZeroValueLabel {
  @apply --progressbarvaluelabel;

  color: var(--blue);
}

.stripes {
  background-size: 50px 50px;
  overflow: hidden;
  animation: stripes-move 1s linear infinite;
  background-image: linear-gradient(-45deg, rgb(255 255 255 / 20%) 25%, transparent 25%, transparent 50%, rgb(255 255 255 / 20%) 50%, rgb(255 255 255 / 20%) 75%, transparent 75%, transparent);}

@keyframes stripes-move {
  0% {
    background-position: 0 0;
  }

  100% {
    background-position: 50px 50px;
  }
}
